import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ReceivedNotification } from '../../entity/notification/notification.model';
import { NotificationStatuses } from '../create-notification/create-notification/create-notification.component';
import { trimValue } from '../../utils/utils';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  animations: [
    trigger('slideDown', [
      state('collapsed', style({
        height: '0',
        overflow: 'hidden',
        opacity: '0'
      })),
      state('expanded', style({
        height: '*',
        overflow: 'visible',
        opacity: '1'
      })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out'))
    ])
  ]
})
export class NotificationItemComponent {

  @Input() notification!: ReceivedNotification;
  @Input() footerFields: any[] = [];
  @Input() isIndicatorVisible: boolean = false;
  @Input() receivedNotifications: boolean = true;
  @Input() tlmKind: 'alarm' | 'request' | null = null;
  /** An alarm's Acknowledge button — off for a user without "uClock Approvals" (X then only discards). */
  @Input() canAcknowledge: boolean = true;

  @Output() toggle = new EventEmitter<ReceivedNotification>();
  @Output() toggleReadStatus = new EventEmitter<{ notification: ReceivedNotification; event?: Event }>();
  @Output() viewConversation = new EventEmitter<ReceivedNotification>();
  @Output() openLinkRequested = new EventEmitter<string>();
  @Output() remove = new EventEmitter<ReceivedNotification>();
  @Output() viewDetails = new EventEmitter<ReceivedNotification>();
  @Output() delete = new EventEmitter<ReceivedNotification>();
  @Output() updateNotificationStatus = new EventEmitter<{notification: ReceivedNotification, newNotificationStatus: NotificationStatuses}>();
  @Output() acknowledge = new EventEmitter<ReceivedNotification>();

  public NotificationStatuses = NotificationStatuses;

  onToggle(): void {
    this.toggle.emit(this.notification);
  }

  onViewDetails(event: Event): void {
    this.viewDetails.emit(this.notification);
  }

  onToggleReadStatus(event?: Event): void {
        event?.stopPropagation();
    this.toggleReadStatus.emit({ notification: this.notification, event });
  }

  onUpdateNotificationStatus(event?: Event, status?: NotificationStatuses): void {
     event?.stopPropagation();
    this.updateNotificationStatus.emit({ notification: this.notification, newNotificationStatus: status });
  }

  onViewConversation(event: any): void {
    event.stopPropagation();
    this.viewConversation.emit(this.notification?.notificationInstance.PK_ID);
  }

  trimValue(value: string){
    return trimValue(value);
  }

  onOpenLink(url: string): void {
    event.stopPropagation();
    this.openLinkRequested.emit(url);
  }

  onAcknowledge(event: Event): void {
    event.stopPropagation();
    this.acknowledge.emit(this.notification);
  }

  onRemove(event: Event): void {
    event.stopPropagation();
    this.remove.emit(this.notification);
  }

  onDelete(event: Event) {
    event.stopPropagation();
    this.delete.emit(this.notification);
  }
}
